'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCrmObjectLifecycleUpdate = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCrmObjectLifecycleUpdate = exports.isCrmObjectLifecycleUpdate = function isCrmObjectLifecycleUpdate(message) {
  return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, message) === _messageTypes.CRM_OBJECT_LIFECYCLE_UPDATE;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate.js
// module id = 380
// module chunks = 2 3